//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref } from '@vue/composition-api'

export default {
  setup() {
    const switch1 = ref(true)
    const switch2 = ref(false)

    return { switch1, switch2 }
  },
}
